import React from 'react';
import { StyledContent, StyledExploreContent, StyledSideBar, StyledWrapper } from './explore-content-layout.styles';


type IExploreContentLayout = React.FC & {
    SideBar: typeof SideBar;
    Content: typeof Content;
    ExploreContent: typeof ExploreContent;
}

export const TechExploreContentLayout: IExploreContentLayout = ({ children }) => (
    <StyledWrapper>
        {children}
    </StyledWrapper>
);

const SideBar: React.FC<{ opened: boolean }> = ({ opened, children }) => (
    <StyledSideBar visible={opened}>
        {children}
    </StyledSideBar>
);

const Content: React.FC = ({ children }) => (
    <StyledContent>
        {children}
    </StyledContent>
);

const ExploreContent: React.FC = ({ children }) => (
    <StyledExploreContent>
        {children}
    </StyledExploreContent>
);

TechExploreContentLayout.SideBar = SideBar;
TechExploreContentLayout.Content = Content;
TechExploreContentLayout.ExploreContent = ExploreContent;